module.exports = __webpack_public_path__ + "img/L1060666.5618cf5b.jpg";